/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fertilizer_UsageInputs */

const vi_fertilizer_usage = /** @type {(inputs: Fertilizer_UsageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Công dụng`)
};

/**

* @param {Fertilizer_UsageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fertilizer_usage = /** @type {((inputs?: Fertilizer_UsageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fertilizer_UsageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fertilizer_usage(inputs)
});